import {
  createSlice,
  type PayloadAction,
  type Reducer,
} from '@reduxjs/toolkit';
import { ROUND_HISTORY_LIMIT } from '@root/constants';
import type { RootState } from '@root/store/store';
import { CombinedRoundState, Round, RoundWinner } from '@root/store/types';

export const ROUND_SLICE_KEY = 'round';

export interface RoundSliceState {
  roundId?: string;
  externalRoundId?: string;
  round: Round<CombinedRoundState> | undefined;
  roundWinner: RoundWinner | undefined;
  availableToBet: boolean;
  roundHistory: string[];
}

export const initialState: RoundSliceState = {
  roundId: undefined,
  externalRoundId: '-',
  round: undefined,
  roundWinner: undefined,
  availableToBet: false,
  roundHistory: [],
};

const roundSlice = createSlice({
  name: ROUND_SLICE_KEY,
  initialState,
  reducers: {
    setRound: (state, action: PayloadAction<Round<CombinedRoundState>>) => {
      state.round = action.payload;
      state.roundId = action.payload.id;
      state.externalRoundId = action.payload.externalRoundId;
    },
    setRoundWinner: (state, action: PayloadAction<RoundWinner | undefined>) => {
      state.roundWinner = action.payload;
    },
    setAvailableToBet: (state, action: PayloadAction<boolean>) => {
      state.availableToBet = action.payload;
    },
    setRoundHistory: (state, action: PayloadAction<string[]>) => {
      state.roundHistory = action.payload.slice(0, ROUND_HISTORY_LIMIT);
    },
    addRoundHistoryResult: (state, action: PayloadAction<string>) => {
      state.roundHistory = [action.payload, ...state.roundHistory].slice(
        0,
        ROUND_HISTORY_LIMIT
      );
    },
    resetRoundSlice: () => initialState,
  },
});

const roundReducer = roundSlice.reducer as Reducer;

export default roundReducer;

export const roundSelector = (state: RootState): RoundSliceState => state.round;

export const roundActions = roundSlice.actions;
